package me.tbsten.compose.preview.lab.previewlab.header

import androidx.compose.foundation.background
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.movableContentOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex
import me.tbsten.compose.preview.lab.previewlab.PreviewLabState
import me.tbsten.compose.preview.lab.ui.PreviewLabTheme
import me.tbsten.compose.preview.lab.ui.components.PreviewLabHorizontalDivider
import me.tbsten.compose.preview.lab.ui.components.PreviewLabVerticalDivider

@Composable
internal fun PreviewLabHeader(
    state: PreviewLabState,
    isHeaderShow: Boolean,
    scale: Float,
    onScaleChange: (Float) -> Unit,
    onOffsetReset: () -> Unit,
    onGridSizeChange: (Dp?) -> Unit,
    isInspectorPanelVisible: Boolean,
    onIsInspectorPanelVisibleToggle: () -> Unit,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) {
    val content = remember(content) { movableContentOf { content() } }

    Column(modifier = modifier.clip(RectangleShape)) {
        if (isHeaderShow) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.dp),
                modifier = Modifier
                    .background(PreviewLabTheme.colors.background)
                    .fillMaxWidth()
                    .horizontalScroll(rememberScrollState())
                    .padding(8.dp)
                    .zIndex(2f)
                    .height(IntrinsicSize.Min),
            ) {
                Zoom(
                    scale = scale,
                    onScaleChange = onScaleChange,
                    onOffsetReset = onOffsetReset,
                )

                PreviewLabVerticalDivider()

                GridSize(
                    gridSize = state.gridSize,
                    onGridSizeChange = onGridSizeChange,
                )

                PreviewLabVerticalDivider()

                InspectorPanelVisible(
                    isInspectorPanelVisible = isInspectorPanelVisible,
                    onToggle = onIsInspectorPanelVisibleToggle,
                )

                PreviewLabVerticalDivider()

                Screenshot(
                    modifier = Modifier.align(Alignment.CenterVertically),
                )

                PlatformHeaders(state = state)
            }

            PreviewLabHorizontalDivider(
                Modifier
                    .zIndex(2f),
            )
        }

        content()
    }
}

@Composable
internal expect fun RowScope.PlatformHeaders(state: PreviewLabState)
